// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__L48Nr","menu-horizontal":"menu_menu-horizontal__qIQQ0","menu-vertical":"menu_menu-vertical__OIRaS"};